import { Show, onMount, onCleanup } from 'solid-js'
import { toastStore, userStore } from '/web/store'

const SubscriptionModal = (props: { show: boolean; onClose: () => void; redirectURL?: string }) => {
  // #217: the payment iframe (PaymentSuccess) posts `subscription-success` / `payment-success`
  // to its parent when the sale completes, but nothing here was listening — so the modal stayed
  // open on "Payment Successful!". Listen for it and auto-close (refreshing sub/profile state so
  // the account reflects the new subscription), matching the ModelPage handler.
  onMount(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!props.show) return
      if (event.data?.type === 'subscription-success' || event.data?.type === 'payment-success') {
        toastStore.success('Successfully subscribed!')
        userStore.loadAIFansSubscriptions()
        userStore.getProfile()
        props.onClose()
      }
    }
    window.addEventListener('message', handleMessage)
    onCleanup(() => window.removeEventListener('message', handleMessage))
  })

  return (
    <Show when={props.show}>
      <div class="fixed inset-0 z-[200] flex items-center justify-center bg-black/80">
        <div class="relative mx-2 w-full max-w-[560px] rounded-xl bg-gradient-to-r from-cosplay-purple to-cosplay-blue-200 p-[2px] md:mx-4">
          <div class="relative h-full w-full overflow-hidden rounded-lg bg-[#0B0F11]">
            <button
              onClick={props.onClose}
              class="absolute right-5 top-4 z-10 text-2xl text-white hover:text-white md:right-6 md:top-6 md:text-gray-400"
            >
              ✕
            </button>
            <div class="h-[880px] max-h-[calc(100vh-140px)] w-full p-3 md:p-6">
              <iframe
                src={props.redirectURL}
                class="h-full w-full"
                style="border: 0;"
                allow="payment"
              />
            </div>
          </div>
        </div>
      </div>
    </Show>
  )
}

export default SubscriptionModal
